import { inject, Injectable } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { EMPTY, Observable } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { ApiService } from "../api/jobimag/api.service";
import { getAccountInfo } from "../api/jobimag/fn/accounts/get-account-info";
import { getServerState } from "../api/jobimag/fn/root/get-server-state";
import { Accounts } from "../api/jobimag/models/accounts";
import { setLoadingState } from "../rxjs/set-loading-state.operator";
import { AppStore } from "./app.store";
@Injectable({
    providedIn: "root"
})
export class AppService {
    private readonly appStore = inject(AppStore);
    private readonly apiService = inject(ApiService);
    private readonly auth = inject(Auth);

    public loadServerState(): Observable<void> {
        return this.apiService.invoke(getServerState).pipe(
            setLoadingState(this.appStore, "loading"),
            map((serverState) => {
                this.appStore.setServerState(serverState);
            }),
            catchError(() => EMPTY)
        );
    }

    public loadCurrentAccount(): Observable<Accounts> {
        return this.apiService.invoke(getAccountInfo).pipe(
            tap((account) => this.appStore.setUserAccount(account)),
            catchError(() => {
                this.logout();
                return EMPTY;
            })
        );
    }

    public async logout(): Promise<void> {
        await this.auth.signOut();
        this.appStore.setUserAccount(null);
    }
}
